import { Component } from '@angular/core';

@Component({
  selector: 'app-step-three-left-panel',
  templateUrl: './step-three-left-panel.component.html',
  styleUrls: ['./step-three-left-panel.component.css']
})
export class StepThreeLeftPanelComponent {

}
